export enum WarehousePropertyDetailMenuEnum {
  overview = 21,
  rentUnitSizeWise
}
